// public -> Menu.vue
<template>
  <v-btn
    name="move"
    color="#c5c5c5"
    light
    small
    absolute
    top
    right
    fab
    outlined
    style="right: 65px;background-color:white;"
    @mousedown="mouseDown"
    @mouseup="mouseUp"
    @click="onClick"
  >
    <v-icon style="color: rgb(71, 75, 78);">mdi-cursor-move</v-icon>
  </v-btn>
</template>
<script>
export default {
  name: 'SortMainMenu',
  props: {
    isSecundary: {
      type: Boolean,
      required: false,
      defualt: true
    }
  },
  computed: {
    ColorSecundary () {
      return this.$store.state.app.ColorSecundary
    },
    Color () {
      return this.$store.state.app.Color
    },
  },
  updated () {
    this.childrenElts = Array.from(this.$refs.tg1.$el.children)
    if (this.draggingElt) {
      var newIndex = this.$store.state.app.menus.indexOf(this.draggingItem)
      this.draggingElt = this.childrenElts[newIndex]
      if (this.draggingElt) {
        this.draggingElt.classList.add('dragging')
      }
    }
  },
  methods: {
    mouseDown (e) {
      e.preventDefault()
      e.stopPropagation()
      var target = e.target
      while (target && !target.classList.contains('itemContent')) {
        target = target.parentElement
      }
      if (target === null) return
      this.childrenElts = Array.from(target.parentElement.children)
      this.parentElement = target.parentElement
      this.list = this.parentElement.parentElement
      this.parentElement.classList.add('dragging')
      this.list.classList.add('dragging')
      var index = this.childrenElts.indexOf(target)
      this.draggingElt = target
      // this.draggingIndex = index
      this.draggingItem = this.$store.state.app.menus[index]
      console.log('index', index)

      target.classList.add('dragging')
      document.addEventListener('mouseup', this.mouseupListener, true)
      document.addEventListener('mousemove', this.mousemoveListener, true)
    },

    mouseupListener (e) {
      console.log('mouseUp', e.target)
      if (this.draggingElt) {
        this.draggingElt.classList.remove('dragging')
      }
      document.removeEventListener('mouseup', this.mouseupListener, true)
      document.removeEventListener('mousemove', this.mousemoveListener, true)

      if (this.draggingElt) {
        this.draggingElt.style.backgroundColor = null
      }
      this.parentElement.classList.remove('dragging')
      this.list.classList.remove('dragging')

      if (this.isSwapped) this.updateSortApi() // llamamos a la api para guardar el nuevo orden

      e.preventDefault()
    },
    onClick (e) {
      e.preventDefault()
      e.stopPropagation()
    },
    mouseUp (e) {
      e.preventDefault()
      e.stopPropagation()
    },
    mousemoveListener (e) {
      var target = e.target
      var dropTargetFound = false
      while (target !== null) {
        if (target.classList.contains('drop-target')) dropTargetFound = true
        if (target.classList.contains('item') && dropTargetFound) {
          if (target === this.dropTarget || target === this.draggingElt) return
          var index = this.childrenElts.indexOf(target)
          if (index >= 0) {
            if (target.classList.contains('itemContents-move')) return
            if (this.$store.state.app.menus[index] === this.draggingItem) return
            var draggingIndex = this.childrenElts.indexOf(this.draggingElt)
            this.dropTarget = target
            target.classList.add('dropping')
            console.log('swapped', draggingIndex, 'to', index)
            this.isSwapped = true
            if (draggingIndex >= 0) {
              var removedItems = this.$store.state.app.menus.splice(draggingIndex, 1)
              this.$store.state.app.menus.splice(index, 0, removedItems[0])
              // this.draggingIndex = index;
              // this.draggingElt = null;
              this.dropTarget.classList.remove('dropping')
              this.dropTarget = null
            }
            return
          }
        }
        target = target.parentElement
      }
    },
  }
}
</script>

<style scope>
  /* .list .itemContent__header {
    padding: 0px;
    background-image: linear-gradient(to top, rgba(128, 128, 128, 0), rgba(0, 0, 0, 0.2));
  } */
  .itemContents .handle::after {
    cursor: move;
    /* content:"≡"; */
    padding-left:7px;
    position:absolute;
    left:0px;
  }
  .itemContents .edit::after {
    cursor: move;
    /* content:"≡"; */
    padding-right:7px;
    position:absolute;
    right:0px;
  }

  ul.itemContents {
    margin: 0;
    padding: 0;
    background-color:red;
    list-style-type: none;
  }
  .list > ul > li::before {
    cursor: move;
    /* content:"≡"; */
    padding-left:0px;
    position:absolute;
    left:0px;
  }

  ul.itemContents > li {
    margin-left:40px;
  }

  .itemContents.dragging {
    box-shadow: 0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12)!important;
  }

  .itemContents.dragging > .item:not(.dragging) .handle::after {
    /* content:">"; */
  }

  .itemContents.dragging .dragging {
    /* content:"≡"; */
  }

  .itemContents-move {
    transition: transform 0.5s;
  }

  /* div.list {
    padding: 0;
  } */
</style>
